import React, { useState } from 'react';
import "./dropdown.css";
import downArrow from "../../images/down-arrow-white.svg"
import downArrowBlack from "../../images/down-arrow-black.svg"

const CustomDropdown = ({ options, value, onChange, placeholder, setOpenDropdown, openCurrentDropdown, setOtherDropdown }) => {

  const handleItemClick = (value) => {
    value=="All"?onChange(""):onChange(value);
    setOpenDropdown(false);
  };

  const handleOpenDropdown = () => {
    setOtherDropdown(false)
    setOpenDropdown(!openCurrentDropdown)
  }

  return (
    <div className={`dropdown ${openCurrentDropdown ? "add-background":""}`}>
      <div className={`dropdown-header ${openCurrentDropdown ? 'filter-dropdown-styling' : ""}`} onClick={handleOpenDropdown}>
        <div>{value || placeholder}</div>
        <img srcSet={openCurrentDropdown ? downArrowBlack : downArrow} className={`arrow ${openCurrentDropdown ? 'open' : ''}`} alt={`${openCurrentDropdown ? 'hide options' : 'view options'}`} />
      </div>
      { openCurrentDropdown && (
        <div className="dropdown-list">
          {options.map((option, index) => (
            <div
              key={index}
              className="dropdown-item"
              onClick={() => handleItemClick(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown